import { render, staticRenderFns } from "./RatingIcon.vue?vue&type=template&id=66cb75a8&scoped=true&"
import script from "./RatingIcon.vue?vue&type=script&lang=ts&"
export * from "./RatingIcon.vue?vue&type=script&lang=ts&"
import style0 from "./RatingIcon.vue?vue&type=style&index=0&id=66cb75a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cb75a8",
  null
  
)

export default component.exports